import { useEffect, useState } from 'react';
import { useAppSelector } from '../../app/hooks';
import { selectIsAIAutoMode } from '../../redux/features/ai/ai.selector';
import {
  selectCurrentTaskAIStatus,
  selectIsCurrentTaskUnsupervised,
} from '../../redux/features/taskRouter/taskRouter.selector';

/**
 * Drives the left-card takeover expansion. On an AI-supervised takeover the
 * whole left card (transcript + reminder + AI status) expands to overlay the
 * left + center area; it auto-collapses when AI auto mode ends, plus a manual
 * close. Lifted out of LiveTranscriptCard so the card — not just the transcript
 * section — is what expands (keeping the reminder + AI status visible).
 *
 * SUPERVISED only: the overlay buries the center menu pane, which is fine while
 * the AI drives and the human just watches the conversation. In unsupervised
 * mode the agent works the order manually and needs that pane, so we skip the
 * overlay there and widen the left PANE instead (see usePaneLayout) — keeping
 * all three panes visible.
 */
const useTranscriptExpand = () => {
  const currentTaskAIStatus = useAppSelector(selectCurrentTaskAIStatus);
  const isAIAutoMode = useAppSelector(selectIsAIAutoMode);
  const isCurrentTaskUnsupervised = useAppSelector(
    selectIsCurrentTaskUnsupervised
  );
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    if (currentTaskAIStatus && !isCurrentTaskUnsupervised) {
      setIsExpanded(true);
    }
    // Mount-only, matching the original TranscriptSliderArea behavior.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isAIAutoMode && isExpanded) {
      setIsExpanded(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAIAutoMode]);

  return { isExpanded, setIsExpanded };
};

export default useTranscriptExpand;
